import styled from 'styled-components';

export const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: row;
  padding: 16px;
  align-items: center;
  @media (max-width: 800px) {
    flex-wrap: wrap;
  }
`;

export const TextInnerFooter = styled.span`
  display: flex;
  align-self: center;
  margin: 0 46px 0 0;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  user-select: none;
  color: currentColor;

  font-weight: 600;
  font-size: 14px;
  line-height: 20px;

  @media (max-width: 800px) {
    flex: 0 0 100%;
    justify-content: center;
    margin-right: 0;
    margin-bottom: 14px;
  }
`;

export const StoresLinks = styled.a`
  display: flex;
  align-self: center;
  text-decoration: none;
  color: currentColor;
`;

const defaultVariant = 'light';
const defaultPosition = 'fixed';

export const Footer = styled.footer<{
  variant?: 'light' | 'dark';
  position?: 'fixed' | 'static' | 'absolute';
}>`
  width: 100%;

  & ${FooterContainer} {
    background-color: ${({ variant = defaultVariant }) =>
      variant === 'light' ? '#fff' : '#001A61'};
    color: ${({ variant = defaultVariant }) =>
      variant === 'light' ? '#3a3a3a' : '#fff'};
  }

  @media (min-width: 800px) {
    position: ${({ position = defaultPosition }) => position};
    bottom: 0;
  }
`;

export const StyledDivider = styled.hr`
  height: 42px;
  width: 0;
  border: none;
  border-right: 0.5px solid currentColor;
  margin: 0 24px;
`;
